
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/social-media-influencer-policy",
      function () {
        return require("private-next-pages/about/social-media-influencer-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/social-media-influencer-policy"])
      });
    }
  